import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/farmacovigilancia/servicios-qms-psmf")({
  head: () => buildRouteHead("/es/servicios/farmacovigilancia/servicios-qms-psmf"),
  component: PVOffering,
});

